import { render, staticRenderFns } from "./GoalConfig.vue?vue&type=template&id=4d92b8f0&"
import script from "./GoalConfig.vue?vue&type=script&lang=js&"
export * from "./GoalConfig.vue?vue&type=script&lang=js&"
import style0 from "./GoalConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports